"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloads = void 0;
var consts_1 = require("../consts");
var downloads = function (event) {
    var _a, _b, _c;
    return {
        event: "downloads",
        eventInfo: "downloads",
        action: ((_a = event === null || event === void 0 ? void 0 : event.eventData) === null || _a === void 0 ? void 0 : _a.action) || consts_1.NOT_AVAILABLE,
        fileName: event.eventData.fileName || consts_1.NOT_AVAILABLE,
        fileLanguage: ((_b = event === null || event === void 0 ? void 0 : event.eventData) === null || _b === void 0 ? void 0 : _b.fileLanguage) || consts_1.NOT_AVAILABLE,
        chapterName: ((_c = event === null || event === void 0 ? void 0 : event.eventData) === null || _c === void 0 ? void 0 : _c.chapterName) || consts_1.NOT_AVAILABLE,
    };
};
exports.downloads = downloads;
